(function() {
  angular.module('nv.singleStudent').component('studentCreditGapsPanelBoxes', {
    // tslint:disable-next-line:max-line-length
    template: require('./student-credit-gaps-panel-boxes.html'),
    bindings: {
      student: '=',
      school: '=',
      studentDiffs: '=',
      studentGapPlans: '=',
      sharedState: '<',
      setSharedState: '&',
    },
    controller: 'StudentCreditGapsPanelBoxesCtrl',
  });
})();
